// extracted by mini-css-extract-plugin
export default {"container":"Card_container__j58Oq","error":"Card_error__w4nN2","sideBySide":"Card_sideBySide__eoRbr","typo":"Card_typo__cJqDB","deckPreview":"Card_deckPreview__6kyDl"};